export interface IPurchaseOrderRecord {
  id: number;
  businessUnit: string;
  poId: string;
  poDate: string;
  poStatus: string;
  supplierId: string;
  supplierName: string;
  buyerId: string;
  buyerName: string;
  poType: string;
  poReference: string;
  [key: string]: unknown;
}

export const purchaseOrders: IPurchaseOrderRecord[] = [
  {
    id: 1,
    businessUnit: "Clinical IT",
    poId: "784215",
    poDate: "04/18/2026",
    poStatus: "Approved",
    supplierId: "55892",
    supplierName: "CareMed Clinical Systems LLC",
    buyerId: "12007",
    buyerName: "Dr. Elena Fischer",
    poType: "Software Subscription",
    poReference: "EMR rollout Q2 2026 hospital integration project",
  },
  {
    id: 2,
    businessUnit: "Clinical IT",
    poId: "784302",
    poDate: "05/02/2026",
    poStatus: "Pending",
    supplierId: "55910",
    supplierName: "CarePoint EMR Technologies",
    buyerId: "12007",
    buyerName: "Dr. Elena Fischer",
    poType: "Professional Services",
    poReference: "Data migration services for legacy archive",
  },
  {
    id: 3,
    businessUnit: "Facilities",
    poId: "785119",
    poDate: "06/11/2026",
    poStatus: "Approved",
    supplierId: "56033",
    supplierName: "TrueCare Digital Healthcare Systems",
    buyerId: "12048",
    buyerName: "Marcus Lee",
    poType: "Hardware",
    poReference: "Workstation refresh for East Emergency",
  },
];

export interface PurchaseOrderSearchCriteria {
  purchaseOrderId?: string | null;
}

const normalize = (s?: string | null) => (s ?? "").trim().toLowerCase();

export const searchPurchaseOrders = (
  criteria: PurchaseOrderSearchCriteria,
): Promise<IPurchaseOrderRecord[]> =>
  new Promise((resolve) => {
    // simulated API latency
    setTimeout(() => {
      const poId = normalize(criteria.purchaseOrderId);

      resolve(
        purchaseOrders.filter(
          (po) => !poId || po.poId.toLowerCase().includes(poId),
        ),
      );
    }, 400);
  });
